import styles from './index.scss'
import classnames from 'classnames'

type PropsType = {
  children: any
  style?: React.CSSProperties
  type?: string
  className?: any
  onClick?: any
}

const DpBgTheme = (props: PropsType) => {
  const { children, ...resProps } = props
  return (
    <div
      {...resProps}
      className={classnames({
        [styles['dp-bg-theme']]: true,
        [styles[`dp-bg-theme--${props?.type}`]]: props?.type,
      }, props?.className)}
    >{children}</div>
  )
}

export default DpBgTheme
